import { atom } from "jotai";
import moment from "moment";

//export const solicitudesAusenciaHistoricoAtom = atom([]);
export const colaboradoresAtom = atom([]);
export const fechaSeleccionadaAtom = atom(moment());
export const totalDiasAtom = atom(moment().daysInMonth());
export const visibleModalProgramarVaccionesAtom = atom(false);
export const refetchColaboradoresAtom = atom(0); 